import { calculateFreeTrialDaysLeft, isCoach } from "../utils/user-helpers";
import { getUserToRequest } from "../views/dashboard/settings/manage-coaches/utils/manage-coaches-utils";

/**
 * If the coach is in free trial mode and it has expired, he must be redirected to upgrade page
 */
function ensureCoachUpgrade({ req, res, locals }, next) {
  const { activeUser, organizationOwner } = locals;

  if (!activeUser) return next();
  const userToRequest = getUserToRequest(activeUser, organizationOwner);

  const coach = isCoach(userToRequest);

  if (
    coach &&
    userToRequest.coachingFreeTrial &&
    !userToRequest.pushAccountInfo
  ) {
    const daysLeft = calculateFreeTrialDaysLeft(userToRequest);
    if (daysLeft < 1) {
      return res.redirect("/coach-billing");
    }
  }

  if (
    coach &&
    !userToRequest.pushAccountInfo &&
    ["unpaid", "canceled"].includes(userToRequest.coachingBilling?.status)
  ) {
    return res.redirect("/coach-billing");
  }

  return next();
}

export default ensureCoachUpgrade;
